import React from 'react';
import { CheckCircle2, AlertTriangle, ShieldAlert, Clock } from 'lucide-react';

const map = {
  pass: {
    icon: CheckCircle2,
    label: 'Compliant',
    classes: 'bg-emerald-500/10 border-emerald-500/20 text-emerald-400',
  },
  warning: {
    icon: AlertTriangle,
    label: 'Validation warning',
    classes: 'bg-amber-500/10 border-amber-500/20 text-amber-400',
  },
  blocking: {
    icon: ShieldAlert,
    label: 'Blocking risk',
    classes: 'bg-red-500/10 border-red-500/20 text-red-400',
  },
  pending: {
    icon: Clock,
    label: 'Needs review',
    classes: 'bg-slate-500/10 border-slate-500/20 text-slate-300',
  },
};

export default function StatusBadge({ status, className = '' }) {
  const cfg = map[status] || map.pending;
  const Icon = cfg.icon;
  return (
    <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs border ${cfg.classes} ${className}`} data-testid={`status-badge-${status}`}>
      <Icon className="h-3.5 w-3.5" />
      {cfg.label}
    </div>
  );
}
